<template>
    <v-snackbar
      v-model="isShow"
      top
    >
      {{ result }}
    </v-snackbar>
</template>

<script>
export default {
  props:{
      isShow: Boolean,
      result: String,
  },
}
</script>

<style>
.v-snack{
  margin-top: 90px;
  white-space: pre-line;
}
</style>